export const ENV_DEV = 'ENV_DEV';
export const ENV_PRODUCTION = 'ENV_PRODUCTION';

export const IS_IN_HOUSE_MASTER = 'REACT_APP_IS_IN_HOUSE_MASTER';
export const IS_DEV = 'REACT_APP_IS_DEV';
export const IS_STAGING = 'REACT_APP_IS_STAGING';
export const IS_AZURE_DEV = 'REACT_APP_IS_AZURE_DEV';
export const IS_AZURE_QA = 'REACT_APP_IS_AZURE_QA';
export const IS_AZURE_PROD = 'REACT_APP_IS_AZURE_PROD';
let env;

switch (process.env.NODE_ENV.trim()) {
  case 'production':
    env = ENV_PRODUCTION;
    break;
  default:
    env = ENV_DEV;
}

const IS_PRODUCTION = env === ENV_PRODUCTION;

export const HOT_RELOAD = !IS_PRODUCTION && process.env.REACT_APP_HOT_RELOAD;

export { env, IS_PRODUCTION };



// WEBPACK FOOTER //
// ./src/env.js